
export default class DynamicDock {
    constructor() {}
  
    DisplayDock(dic, op) {
        this.TurnOffAllNodes();
        switch (op) {
            case "off":
                console.log("Turning on Nothing nodes");
                break;
            case "on":
                console.log("Turning on All nodes");
                this.TurnOnAllNodes();
                break;
            default:
                console.log("Turning on \"" +op+ "\" nodes");
                //this.NodesToTurnOn(dic,op);
                this.TurnOnNodesByName(this.NodesToTurnOn(dic,op));
        }
    }

    NodesToTurnOn(dic,op){
        var nodes = dic[op];
        var retObj = [];
        for(var i = 0; i< nodes.length;i++){
            var tempstring = nodes[i].nodename;
            tempstring = tempstring.toLowerCase();
            tempstring = tempstring.replace(' ','-');
            tempstring = "node " + tempstring;
            retObj.push(tempstring);
        }

        console.log(JSON.stringify(retObj));
        return retObj;
    }

    TurnOnNodesByName(Nodes){
        console.log("Trying to turn on Nodes:" + JSON.stringify(Nodes));
        for(var i = 0; i< Nodes.length;i++){
            document.getElementsByClassName("dock")[0].getElementsByClassName(Nodes[i])[0].style.display = "";
        }
    }

    TurnOffAllNodes(){
        var children = document.getElementsByClassName("dock")[0].children;
        for (var i = 0; i < children.length; i++) {
            children[i].children[0].style.display = "none";
        }
    }
    TurnOnAllNodes(){
        var children = document.getElementsByClassName("dock")[0].children;
        for (var i = 0; i < children.length; i++) {
            children[i].children[0].style.display = "";
        }
    }

    CreateDrawerItems(cats){
        var retObjs = [{operation: "on", text: "All On"},{operation: "off", text: "All Off"}];
        for(var key in cats) {
            var item = cats[key];
            retObjs.push({operation: item[0].category, text: item[0].category})
        }
        return retObjs;  
    }
    

  }